import { SVGProps } from 'react';

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill={props.color} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12.436 4L4.43604 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.43604 4L12.436 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
